import {HierarchyTableNode} from '../types'

export type ExpertSystemUsageLocationHistory = {
  id: string
  name: string
}

export const findPathToNode = (
  nodes: HierarchyTableNode[],
  targetId: string,
  path: ExpertSystemUsageLocationHistory[] = []
): ExpertSystemUsageLocationHistory[] | null => {
  for (const node of nodes) {
    const newPath = [...path, {id: node.id, name: node.name}]
    if (node.id === targetId) return newPath
    if (node.subItems) {
      const result = findPathToNode(node.subItems, targetId, newPath)
      if (result) return result
    }
  }
  return null
}

export const resolveNavigationFromHistory = (
  rootNodes: HierarchyTableNode[],
  locationHistory: ExpertSystemUsageLocationHistory[],
  targetId: string
): {
  newHistory: ExpertSystemUsageLocationHistory[]
  siblings: ExpertSystemUsageLocationHistory[]
} | null => {
  const indexInHistory = locationHistory.findIndex((location) => location.id === targetId)

  if (indexInHistory === -1) return null

  const newHistory = locationHistory.slice(0, indexInHistory + 1)
  const parentPath = locationHistory.slice(0, indexInHistory)

  const parent = parentPath.reduce<HierarchyTableNode | HierarchyTableNode[]>(
    (current, historyItem) => {
      if (!current) return rootNodes
      if (Array.isArray(current)) {
        return current.find((node) => node.id === historyItem.id)?.subItems || []
      }
      return current.subItems?.find((node) => node.id === historyItem.id)?.subItems || []
    },
    rootNodes
  )

  let siblings: ExpertSystemUsageLocationHistory[] = []

  if (Array.isArray(parent)) {
    siblings = parent.map(({id, name}) => ({id, name}))
  } else if (parent && 'subItems' in parent && Array.isArray(parent.subItems)) {
    siblings = parent.subItems.map(({id, name}) => ({id, name}))
  }

  return {
    newHistory,
    siblings
  }
}
